import { useMemo } from "react";
import { format } from "d3-format";

const useFormat = (fmt: string) => {
  return useMemo(() => format(fmt), [fmt]);
};

export default useFormat;
